import React from "react";
import "./Message.css";

const Message = (props) => {
  return (
    <div className="alert alert-warning message">
      <h5>We are Sorry!</h5>
      <p className="card-text">
        We can't seem to find any accessories that match your search for{" "}
        <b>{props.title}</b> .
      </p>
      <p>
        Need assistance ?
        <div className="custom-column-footer">
          <a
            className="btn btn-primary btn-lg assistance-width"
            href="#contact"
          >
            Contact Us
          </a>
        </div>
      </p>
    </div>
  );
};
export default Message;
